import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const NewsService = {
    addNews,
    searchNews,
    getNews,
    editNews,
    remove,
    sendNotification,
    unsubscribe_news
};

function addNews(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "news/addNews/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function searchNews(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "news/searchNews/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getNews(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "news/getNews/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function editNews(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "news/editNews/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function remove(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "news/remove/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function sendNotification(data) {
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "notification/broadcast", data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function unsubscribe_news(data){
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL+'news/unsubscribe', data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}